import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Vue from 'vue'
import App from './App.vue'
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';

miniToastr.init()

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options)
Vue.config.productionTip = false
Vue.prototype.UrlBase = '/app.php';
Vue.prototype.UrlImgDrive = 'https://lh3.google.com/u/0/d/'

new Vue({
  render: h => h(App),
}).$mount('#app')
